import React, {FC} from 'react';
import styled from 'styled-components';

import {
  ButtonGroup,
  ButtonGroupProps,
} from '../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  margin: 0 20px 20px 20px;
`;

/*
 * Component.
 */

export const DialogButtonGroup: FC<ButtonGroupProps> = (props) => (
  <StyledWrapperDiv>
    <ButtonGroup {...props}>{props.children}</ButtonGroup>
  </StyledWrapperDiv>
);
